import { Controller } from "@hotwired/stimulus"

// Add/remove free-text custom items on the document request form.
export default class extends Controller {
  static targets = ["list", "template"]

  add() {
    const node = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(node)
    node.querySelector("input")?.focus()
  }

  remove(event) {
    const row = event.target.closest("[data-sales-request-items-target='row']")
    row?.remove()
  }
}
